const modalEditPhotoFormEquip = {
  title: 'Editar foto del equipo'
};

export default modalEditPhotoFormEquip;
